import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import validationAddUserMarketer from "../../../validtions/forms/marketer/add-user";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import { useHistory } from "react-router-dom";

export default function AddUserByMarketer() {
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState();
  const [userMarketerInfo, setUserMarketerInfo] = useState();
  const history = useHistory();

  useEffect(() => {
    getUserMarketerInfo();
  }, []);

  const getUserMarketerInfo = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllSiteUserAdvertiser =
      await sendRequestGetUserMarketerInfo();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllSiteUserAdvertiser) {
      return;
    }

    setUserMarketerInfo(resultSendRequestGetAllSiteUserAdvertiser);
  };

  const sendRequestGetUserMarketerInfo = async () => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/info",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`} dir="rtl">
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const sendForm = async () => {
    const formData = getDateForm();
    const resultValidationAddUserMarketer =
      validationAddUserMarketer.validateFormAddUser(formData);
    if (resultValidationAddUserMarketer != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationAddUserMarketer,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddUser = await sendRequestAddUser(formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddUser) {
      return;
    }
    history.push("/marketer/all-user-registered");
  };

  const sendRequestAddUser = async (dataForm) => {
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/add-user",
        dataForm,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return true;
  };

  const getDateForm = () => {
    return {
      identity_marketer: userMarketerInfo.identity_marketer,
      mobile: document.querySelector("#mobile").value.trim(),
      email: document.querySelector("#email").value.trim(),
      password: document.querySelector("#password").value.trim(),
    };
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateForm = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          sendForm();
        }}
      >
        <div className="form-group">
          <label>شماره موبایل</label>
          <input
            type="number"
            className="form-control"
            id="mobile"
            placeholder="09121234567"
            onWheel={(event) => event.currentTarget.blur()}
            required
          />
        </div>
        <div className="form-group">
          <label>ایمیل</label>
          <input
            tabIndex="1"
            dir="rtl"
            type="email"
            id="email"
            className="form-control"
            required
          />
        </div>
        <div
          dir="ltr"
          className="flex-1 form-group  d-flex align-items-end flex-column"
        >
          <label>رمز عبور</label>
          <div dir="rtl" className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              id="password"
              min="8"
              required
            />
            <div className="input-group-append">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  setShowPassword((prevState) => !prevState);
                }}
              >
                <i
                  className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                ></i>
              </button>
            </div>
          </div>
        </div>

        <div className="form-group">
          <button className="btn btn-success">اضافه کردن</button>
        </div>
      </form>
    );
  };

  return (
    <>
      <Sidebar openItem="users-marketer" activeItem="add-user-by-marketer" />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن کاربر" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              {userMarketerInfo && generateForm()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
